<template>
  <div style="padding: 20px 0">
    <div class="bread-cream flex-row">
      <div v-for="(item, index) in data" :key="item.to">
        <template v-if="item.to">
          <router-link :to="item.to">{{ item.title }}</router-link>
        </template>
        <template v-else>
          <span>{{ item.title }}</span>
        </template>
        <span class="segmentation" v-if="index !== data.length - 1">/</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {},
  name: "FriendShip",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    return {};
  },
});
</script>
<style lang="scss" scoped>
.bread-cream {
  height: 18px;
  font-size: 12px;
  color: #423e3d;
  line-height: 18px;
  a {
    height: 18px;
    font-size: 12px;
    color: #423e3d;
    line-height: 18px;
    &:hover {
      color: #423e3d;
    }
  }
  .segmentation {
    margin: 0 5px;
  }
}
</style>
